import React, {useState} from 'react';
import Flex from '../../Flex';
import FormElement from '../../FormElement';
import styles from './styles.module.scss';

import bgIcon from '../../../assets/images/background/image.png';
import truckIcon from '../../../assets/images/truck-icon-blue/image@3x.png';
import moment from 'moment';
import strings from '../../../globalization';

const STATUSES = {
  ISSUED: 'ISSUED',
  HOLD: 'HOLD',
  PENDING: 'PENDING',
  SURRENDERED: 'SURRENDER',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  OPERATOR_ADMIN_APPROVED: 'OPERATOR_ADMIN_APPROVED',
};

function ValidateVehiclePopup({
  containerClass,
  formData,
  stateData,
  onClose,
  viewHistory,
  vehicle,
  onClick,
  vehicleRejectReasons,
  pageStatus,
  componentType,
}) {
  console.log('stateData', stateData);
  console.log('vehicle', vehicle);
  console.log('formData', formData);

  const [verifiedDetails, setVerifiedDetails] = useState(null);
  const [error, setError] = useState(null);
  const getStatus = () => {
    let status = vehicle.status;

    switch (status) {
      case STATUSES.ISSUED: {
        return 'Issued';
      }
      case STATUSES.HOLD: {
        return 'On Hold';
      }
      case STATUSES.SURRENDERED: {
        return 'Surrendered';
      }
      case STATUSES.PAYMENT_COMPLETED: {
        return 'Payment Completed';
      }
      case STATUSES.PAYMENT_PENDING: {
        return 'Payment Pending';
      }
      case STATUSES.PAYMENT_FAILED: {
        return 'Payment Failed';
      }
      default: {
        return status;
      }
    }
  };

  const getButtons = () => {
    return (
      <div className={styles.finalButtons}>
        <button className={styles.back} onClick={() => onClick('back')}>
          {`Back`}
        </button>
        <button className={styles.reject} onClick={handleReject}>
          {`Reject`}
        </button>
        <button className={styles.approve} onClick={handleApprove}>
          {strings.approve}
        </button>
      </div>
    );
  };

  const getStyles = () => {
    let status = vehicle.status;

    switch (status) {
      case STATUSES.ISSUED: {
        return {
          padding: '2px 10px',
          borderRadius: '5px',
          backgroundColor: '#0AC15770',
        };
      }
      case STATUSES.HOLD: {
        return {
          padding: '2px 10px',
          borderRadius: '5px',
          backgroundColor: '#E6771770',
        };
      }
      case STATUSES.SURRENDERED: {
        return {
          padding: '2px 10px',
          borderRadius: '5px',
          backgroundColor: '#E6771770',
        };
      }
      default: {
        return {
          padding: '2px 10px',
          borderRadius: '5px',
          backgroundColor: '#0045E670',
        };
      }
    }
  };

  const getFormData = () => {
    return (
      <Flex direction="row" className={styles.columnLayout}>
        {formData.map((elem, idx) => {
          return (
            <FormElement
              type={elem.elementType}
              label={elem.label}
              required={elem.required}
              placeholderText={elem.placeholder}
              tabIndex={idx}
              options={stateData[elem.optionsField]}
              // value={stateData[elem.stateField].value}
              fileIcon={vehicle[elem.fileIcon]}
              value={vehicle[elem.id]}
              key={`firstColumn-${idx}`}
              maxLength={elem.maxLength}
              disabled={true}
              defaultValue={vehicle[elem.id]}
              containerClassNames={styles.containerClassNames}
              labelClassNames={styles.labelClassNames}
              onRightIconClick={() =>
                onClick('document-view', vehicle[elem.fileIcon])
              }
            />
          );
        })}
      </Flex>
    );
  };

  const getImageColumn = () => {
    return (
      <Flex direction="column" className={styles.imageTextContainer}>
        <img src={truckIcon} className={styles.image} alt="AVATAR" />
        {/* <img src={bgIcon} className={styles.image} alt="AVATAR" /> */}
        <p className={styles.text}>
          {strings.referenceNumberLabel}: {vehicle.referenceId}
        </p>
        <p className={styles.text}>
          {strings.requestDate}:{' '}
          {moment(vehicle.createdDate).format('DD/MM/YYYY')}
        </p>
        <p className={styles.text}>
          {strings.status}: <span style={getStyles()}>{getStatus()}</span>
        </p>
        <button
          className={styles.history}
          onClick={() => viewHistory(vehicle.referenceId)}>
          {strings.viewHistory}
        </button>
      </Flex>
    );
  };

  const handleApprove = () => {
    if (!verifiedDetails) {
      setError(`Please verify all the details`);
      return;
    }
    onClick('handle-approve-vehicle', {
      id: vehicle.id,
    });
  };
  const handleReject = () => {};

  const getPageContent = () => {
    console.log('pageStatus...', pageStatus);
    switch (pageStatus) {
      case 'reject': {
        return (
          <Reject
            vehicle={vehicle}
            vehicleRejectReasons={vehicleRejectReasons}
            onClick={onClick}
          />
        );
      }
      default: {
        return (
          <Flex direction="column">
            <Flex direction="row">
              {getFormData()}
              {getImageColumn()}{' '}
            </Flex>
            {/* <label
              className={styles.radioLabelUniversal}
              onChange={e => setVerifiedDetails(e.target.value)}>
              <input type="radio" name="verifiedDetails" value={1} />
              Verified Details
            </label> */}
            <Flex direction="row" style={{alignItems: 'center'}}>
              <input
                id="verifiedDetails"
                type="radio"
                name="verifiedDetails"
                value={1}
                onChange={e => setVerifiedDetails(e.target.value)}
              />
              <label
                htmlFor="verifiedDetails"
                style={{paddingLeft: '10px'}}
                className={styles.radioLabelUniversal}
                onChange={e => setVerifiedDetails(e.target.value)}>
                Verified Details
              </label>
            </Flex>
            {<p className={styles.rejectText}>{error}</p>}
            <Flex className={styles.buttonsContainer}>
              <div className={styles.finalButtons}>
                <button className={styles.back} onClick={() => onClick('back')}>
                  {`Back`}
                </button>
                {vehicle.status === STATUSES.OPERATOR_ADMIN_APPROVED &&
                  componentType !== 'VIEW' && (
                    <>
                      <button
                        className={styles.reject}
                        onClick={() => onClick('handle-reject-page-status')}>
                        {`Reject`}
                      </button>
                      <button
                        className={styles.approve}
                        onClick={handleApprove}>
                        {strings.approve}
                      </button>
                    </>
                  )}
              </div>
            </Flex>
          </Flex>
        );
      }
    }
  };

  return (
    <div className={[styles.container, containerClass].join(' ')}>
      <Flex className={styles.mainContainer}>{getPageContent()}</Flex>
    </div>
  );
}

const Reject = ({vehicle, vehicleRejectReasons, onClick}) => {
  const [rejectReasonId, setRejectReasonId] = useState(null);
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');
  const onChangeValue = e => {
    console.log(e.target.value);
    setRejectReasonId(e.target.value);
  };

  const onReject = () => {
    if (!rejectReasonId) {
      setError('Please select reject reason');
      return;
    }
    if (!remark) {
      setError('Please enter a remark');
      return;
    }
    onClick('handle-reject-vehicle', {
      id: vehicle.id,
      rejectReasonId: +rejectReasonId,
      remark,
    });
  };
  return (
    <div style={{width: '100%'}}>
      <p>
        Reference Number:{' '}
        <span className={styles.referenceId}>{vehicle?.referenceId}</span>
      </p>

      <Flex
        direction="column"
        onChange={e => onChangeValue(e)}
        className={styles.radioContainer}>
        <p className={styles.radioHeader}>Reason for rejection</p>
        {vehicleRejectReasons.map((reason, idx) => (
          <>
            {/* <label
              key={`${idx}-${reason.id}-${reason.reason}`}
              className={styles.radioLabel}>
              <input type="radio" name="reason" value={reason.id} />
              {reason.reason}
            </label> */}
            <Flex direction="row" style={{alignItems: 'center'}}>
              <input
                type="radio"
                name="reason"
                id={`reject-reason-${idx}`}
                value={reason.id}
              />
              <label
                htmlFor={`reject-reason-${idx}`}
                style={{paddingLeft: '10px'}}
                key={`${idx}-${reason.id}-${reason.reason}`}
                className={styles.radioLabel}>
                {reason.reason}
              </label>
            </Flex>
          </>
        ))}
      </Flex>
      <div>
        <textarea
          onChange={e => setRemark(e.target.value)}
          rows="5"
          placeholder="Enter remarks..."
          className={styles.rejectTextarea}
          style={{width: '100%'}}></textarea>
      </div>
      <p className={styles.rejectText}>{error}</p>
      <Flex className={styles.buttonsContainer}>
        <div className={styles.finalButtons}>
          <button
            className={styles.back}
            onClick={() => onClick('reset-page-status')}>
            {`Back`}
          </button>

          <button className={styles.reject} onClick={onReject}>
            {`Reject`}
          </button>
        </div>
      </Flex>
    </div>
  );
};

export default ValidateVehiclePopup;
